Vue.component('giveExclusiveCard', {
  template: templates.giveExclusiveCard,
  data() {
    return {
      model: {
        cardId: null,
        cards: {},
        userCards: {},
        searchResults: [],
        saving: false,
        connectionId: null,
        selectedUserTwitchId: null,
        selectedUserDisplayName: null,
        twitchId: utils.cookies.get('user_id')
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.connect();
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
        const messageData = event.data;

        try {
          const parsedData = JSON.parse(messageData);
          if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.message === 'exclusive_card_given'){
            c.get();
          }
        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },

    get() {
      const c = this;
      // Directly load user's owned exclusive cards
      c.getUserExclusiveCards();
    },

    getUserExclusiveCards() {
      const c = this;

      if (!c.model.twitchId) {
        console.error('No twitchId available');
        return;
      }

      // Make API call to get streamer's owned exclusive cards (aggregated by cardId with quantity)
      axios.get(`/api/exclusive-card/user-cards.php?twitchId=${c.model.twitchId}`)
        .then(function (response) {
          let data = {};
          if (Array.isArray(response.data)) {
            for (let card of response.data) {
              data[`${card.cardId}`] = card;
            }
          }
          c.model.userCards = data;
        })
        .catch(function (error) {
          console.error('Failed to load user exclusive cards:', error);
        });
    },

    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="exclusive-card-user"]').val();

      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data;

          const userMap = {};
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
            userMap[data.twitchDisplayName] = {
              twitchId: data.twitchId,
              connectionId: data.connectionId
            };
          }

          $('[name="exclusive-card-user"]').autocomplete({
            source: names,
            select: function(event, ui) {
              const selectedDisplayName = ui.item.value;
              const userData = userMap[selectedDisplayName];
              c.model.selectedUserTwitchId = userData.twitchId;
              c.model.selectedUserDisplayName = selectedDisplayName;
              c.model.connectionId = userData.connectionId;
            }
          });
        })
        .catch(function (error) {
          console.error("Error fetching users:", error);
        });
    },

    save() {
      const c = this;

      if (!c.model.cardId) {
        utils.alert.error('Please select a card');
        return;
      }

      if (!c.model.selectedUserTwitchId) {
        utils.alert.error('Please select a user');
        return;
      }

      c.model.saving = true;

      const giveawayData = {
        cardId: c.model.cardId,
        recipientTwitchId: c.model.selectedUserTwitchId,
        recipientDisplayName: c.model.selectedUserDisplayName,
        channelId: utils.cookies.get('channelId'),
        connectionId: c.model.connectionId
      };

      exclusiveCardService.giveaway(giveawayData)
        .then(function (response) {
          if (response.status === 200) {
            utils.alert.success(`Card given to ${c.model.selectedUserDisplayName}!`);

            // Broadcast via WebSocket
            if (c.ws && c.ws.readyState === WebSocket.OPEN) {
              c.ws.send(JSON.stringify({
                channelId: utils.cookies.get('channelId'),
                message: 'exclusive_card_given',
                cardId: c.model.cardId,
                recipientTwitchId: c.model.selectedUserTwitchId,
                recipientDisplayName: c.model.selectedUserDisplayName
              }));
            }

            // Reset form
            c.model.cardId = null;
            c.model.selectedUserTwitchId = null;
            c.model.selectedUserDisplayName = null;
            $('[name="exclusive-card-user"]').val('');

            // Reload cards
            c.get();
            c.model.saving = false;
          }
        })
        .catch(function (error) {
          console.error('Giveaway error:', error);

          if (error.response && error.response.data && error.response.data.error) {
            utils.alert.error(error.response.data.error);
          } else {
            utils.alert.error('Failed to give away card');
          }

          c.model.saving = false;
        });
    }
  }
});
